module.exports = __webpack_public_path__ + "img/photography_thumbnail.85c3328e.jpg";